import { Button, ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import { useViewingArticle } from "@/hooks";
import CourseInfo from "./CourseInfo";
import ProductInfo from "./ProductInfo";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function NeedLogin(_ref) {
  var _episode$rights$;
  let {
    watch,
    withContract
  } = _ref;
  const {
    setViewingArticle,
    loading
  } = useViewingArticle();
  const {
    episode,
    howtoPlay
  } = watch;
  const handleClick = useCallback(() => {
    if (episode.rights_control_type === "entitled_only") {
      const viewingArticlePayload = (() => {
        if (howtoPlay.courses.length > 0) {
          return {
            type: "svod",
            id: howtoPlay.courses.map(c => Number(c.id))
          };
        } else if (howtoPlay.products.length > 0) {
          return {
            type: "tvod",
            id: howtoPlay.products.map(p => Number(p.id))
          };
        }
      })();
      setViewingArticle(viewingArticlePayload, false, routes.login);
    } else {
      window.location.href = routes.login;
    }
  }, [episode]);
  const isMemberFree = (episode === null || episode === void 0 ? void 0 : episode.rights_control_type) === "member_only" && (episode === null || episode === void 0 || (_episode$rights$ = episode.rights[0]) === null || _episode$rights$ === void 0 ? void 0 : _episode$rights$.price) === 0;
  const headerMessage = (() => {
    if (isMemberFree) {
      return "この作品をご視聴いただくには会員登録が必要です";
    } else if (howtoPlay.courses.length > 0) {
      return "この作品をご視聴いただくには会員登録と以下の月額商品の購入が必要です";
    } else {
      return "この作品を購入するには会員登録が必要です";
    }
  })();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "needlogin",
      children: [/*#__PURE__*/_jsx("h3", {
        children: headerMessage
      }), /*#__PURE__*/_jsx(Button, {
        fillColor: true,
        large: true,
        className: styles.overlayRegistBtn,
        onClick: handleClick,
        children: "\u7121\u6599\u3067\u4F1A\u54E1\u767B\u9332\u3059\u308B"
      }), /*#__PURE__*/_jsxs("ul", {
        className: styles.note,
        children: [/*#__PURE__*/_jsx("li", {
          children: "\u4F5C\u54C1\u306E\u8CFC\u5165\u306B\u306F\u6240\u5B9A\u306E\u6599\u91D1\u304C\u304B\u304B\u308A\u307E\u3059\u3002"
        }), /*#__PURE__*/_jsx("li", {
          children: "\u30B5\u30FC\u30D3\u30B9\u3092\u304A\u697D\u3057\u307F\u3044\u305F\u3060\u304F\u305F\u3081\u306B\u306F\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u3054\u767B\u9332\u304C\u5FC5\u8981\u3067\u3059\u3002"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.login,
        children: [/*#__PURE__*/_jsx("span", {
          children: "\u65E2\u306B\u4F1A\u54E1\u306E\u65B9"
        }), /*#__PURE__*/_jsx(ButtonLink, {
          href: routes.login,
          borderGray: true,
          fontFixed: true,
          fontBold: true,
          children: "\u30ED\u30B0\u30A4\u30F3\u3059\u308B"
        })]
      }), withContract && howtoPlay.courses.length > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.contractInfo,
        children: howtoPlay.courses.length > 0 && howtoPlay.courses.map(course => /*#__PURE__*/_jsx(CourseInfo, {
          course: course,
          isLoggedIn: false
        }, `course-${course.id}`))
      }), withContract && howtoPlay.products.length > 0 && /*#__PURE__*/_jsx("div", {
        children: howtoPlay.products.map(product => /*#__PURE__*/_jsx(ProductInfo, {
          product: product,
          rights: howtoPlay.rights,
          isLoggedIn: false
        }, `product-${product.id}`))
      })]
    })
  });
}